import * as actionType from './InvestorType';

export const getInvestorsRequest = (data) => ({
    type: actionType.GET_INVESTORS_REQUEST,
    payload: data,
});
export const getInvestorsSuccess = (data) => ({
    type: actionType.GET_INVESTORS_SUCCESS,
    payload: data,
});
export const getInvestorsFailure = (error) => ({
    type: actionType.GET_INVESTORS_FAILURE,
    payload: error,
});

export const getInvestorByIdRequest = (data) => ({
    type: actionType.GET_INVESTOR_BY_ID_REQUEST,
    payload: data,
});
export const getInvestorByIdSuccess = (data) => ({
    type: actionType.GET_INVESTOR_BY_ID_SUCCESS,
    payload: data,
});
export const getInvestorByIdFailure = (error) => ({
    type: actionType.GET_INVESTOR_BY_ID_FAILURE,
    payload: error,
});

export const getInvestmentViewDetailsRequest = (data) => ({
    type: actionType.GET_INVESTMENT_VIEW_DETAILS_REQUEST,
    payload: data,
});
export const getInvestmentViewDetailsSuccess = (data) => ({
    type: actionType.GET_INVESTMENT_VIEW_DETAILS_SUCCESS,
    payload: data,
});
export const getInvestmentViewDetailsFailure = (error) => ({
    type: actionType.GET_INVESTMENT_VIEW_DETAILS_FAILURE,
    payload: error,
});

export const getInvestmentDetailsByInvestmentIdRequest = (data) => ({
    type: actionType.GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_REQUEST,
    payload: data,
});
export const getInvestmentDetailsByInvestmentIdSuccess = (data) => ({
    type: actionType.GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_SUCCESS,
    payload: data,
});
export const getInvestmentDetailsByInvestmentIdFailure = (error) => ({
    type: actionType.GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_FAILURE,
    payload: error,
});

export const deleteInvestorRequest = (data) => ({
    type: actionType.DELETE_INVESTOR_REQUEST,
    payload: data,
});
export const deleteInvestorSuccess = (data) => ({
    type: actionType.DELETE_INVESTOR_SUCCESS,
    payload: data,
});
export const deleteInvestorFailure = (error) => ({
    type: actionType.DELETE_INVESTOR_FAILURE,
    payload: error,
});

export const saveInvestorRequest = (data) => ({
    type: actionType.SAVE_INVESTOR_REQUEST,
    payload: data,
});
export const saveInvestorSuccess = (data) => ({
    type: actionType.SAVE_INVESTOR_SUCCESS,
    payload: data,
});
export const saveInvestorFailure = (error) => ({
    type: actionType.SAVE_INVESTOR_FAILURE,
    payload: error,
});

export const deleteInvestmentDetailsByInvestorInvestmentIDRequest = (data) => ({
    type: actionType.DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_REQUEST,
    payload: data,
});
export const deleteInvestmentDetailsByInvestorInvestmentIDSuccess = (data) => ({
    type: actionType.DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_SUCCESS,
    payload: data,
});
export const deleteInvestmentDetailsByInvestorInvestmentIDFailure = (error) => ({
    type: actionType.DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_FAILURE,
    payload: error,
});

export const getPreferredBulkDataRequest = (data) => ({
    type: actionType.GET_PREFERRED_BULK_DATA_REQUEST,
    payload: data,
});
export const getPreferredBulkDataSuccess = (data) => ({
    type: actionType.GET_PREFERRED_BULK_DATA_SUCCESS,
    payload: data,
});
export const getPreferredBulkDataFailure = (error) => ({
    type: actionType.GET_PREFERRED_BULK_DATA_FAILURE,
    payload: error,
});

export const getCatchUpBulkDataRequest = (data) => ({
    type: actionType.GET_CATCHUP_BULK_DATA_REQUEST,
    payload: data,
});
export const getCatchUpBulkDataSuccess = (data) => ({
    type: actionType.GET_CATCHUP_BULK_DATA_SUCCESS,
    payload: data,
});
export const getCatchUpBulkDataFailure = (error) => ({
    type: actionType.GET_CATCHUP_BULK_DATA_FAILURE,
    payload: error,
});

export const getHoldCoBulkDataRequest = (data) => ({
    type: actionType.GET_HOLDCO_BULK_DATA_REQUEST,
    payload: data,
});
export const getHoldCoBulkDataSuccess = (data) => ({
    type: actionType.GET_HOLDCO_BULK_DATA_SUCCESS,
    payload: data,
});
export const getHoldCoBulkDataFailure = (error) => ({
    type: actionType.GET_HOLDCO_BULK_DATA_FAILURE,
    payload: error,
});

export const savePreferredBulkDataRequest = (data) => ({
    type: actionType.SAVE_PREFERRED_BULK_DATA_REQUEST,
    payload: data,
});
export const savePreferredBulkDataSuccess = (data) => ({
    type: actionType.SAVE_PREFERRED_BULK_DATA_SUCCESS,
    payload: data,
});
export const savePreferredBulkDataFailure = (error) => ({
    type: actionType.SAVE_PREFERRED_BULK_DATA_FAILURE,
    payload: error,
});

export const saveCatchUpBulkDataRequest = (data) => ({
    type: actionType.SAVE_CATCHUP_BULK_DATA_REQUEST,
    payload: data,
});
export const saveCatchUpBulkDataSuccess = (data) => ({
    type: actionType.SAVE_CATCHUP_BULK_DATA_SUCCESS,
    payload: data,
});
export const saveCatchUpBulkDataFailure = (error) => ({
    type: actionType.SAVE_CATCHUP_BULK_DATA_FAILURE,
    payload: error,
});

export const saveHoldCoBulkDataRequest = (data) => ({
    type: actionType.SAVE_HOLDCO_BULK_DATA_REQUEST,
    payload: data,
});
export const saveHoldCoBulkDataSuccess = (data) => ({
    type: actionType.SAVE_HOLDCO_BULK_DATA_SUCCESS,
    payload: data,
});
export const saveHoldCoBulkDataFailure = (error) => ({
    type: actionType.SAVE_HOLDCO_BULK_DATA_FAILURE,
    payload: error,
});
export const exportEquityUserRequest = (data) => ({
    type: actionType.EXPORT_EQUITY_USER_REQUEST,
    payload: data,
});
export const exportEquityUserDataSuccess = (data) => ({
    type: actionType.EXPORT_EQUITY_USER_SUCCESS,
    payload: data,
});
export const exportEquityUserDataFailure = (error) => ({
    type: actionType.EXPORT_EQUITY_USER_FAILURE,
    payload: error,
});
export const importtEquityUserRequest = (data) => ({
    type: actionType.IMPORT_EQUITY_USER_REQUEST,
    payload: data,
});
export const importEquityUserDataSuccess = (data) => ({
    type: actionType.IMPORT_EQUITY_USER_SUCCESS,
    payload: data,
});
export const importEquityUserDataFailure = (error) => ({
    type: actionType.IMPORT_EQUITY_USER_FAILURE,
    payload: error,
});
export const clearEquityUserExport = () => ({
    type: actionType.CLEAR_EQUITY_USER_EXPORT,
});
export const clearImportEquityUserSuccess = () => ({
    type: actionType.CLEAR_IMPORT_EQUITY_USER_SUCCESS,
});

export const clearInvestorDetails = () => ({
    type: actionType.CLEAR_INVESTOR_DETAILS,
});

export const publishInvestmentRequest = (data) => ({
    type: actionType.PUBLISH_INVESTMENT_REQUEST,
    payload: data,
});
export const publishInvestmentSuccess = (data) => ({
    type: actionType.PUBLISH_INVESTMENT_SUCCESS,
    payload: data,
});
export const publishInvestmentFailure = (error) => ({
    type: actionType.PUBLISH_INVESTMENT_FAILURE,
    payload: error,
});
export const clearPublishInvestment = () => ({
    type: actionType.CLEAR_PUBLISH_INVESTMENT,
});

export const fetchEquityImportBatchListRequest = (data) => ({
    type: actionType.FETCH_EQUITY_IMPORT_BATCH_LIST_REQUEST,
    payload: data,
});
export const fetchEquityImportBatchListSuccess = (data) => ({
    type: actionType.FETCH_EQUITY_IMPORT_BATCH_LIST_SUCCESS,
    payload: data,
});
export const fetchEquityImportBatchListFailure = (error) => ({
    type: actionType.FETCH_EQUITY_IMPORT_BATCH_LIST_FAILURE,
    payload: error,
});

export const downloadEquityImportRecordsRequest = (data) => ({
    type: actionType.DOWNLOAD_EQUITY_IMPORT_RECORDS_REQUEST,
    payload: data,
});
export const downloadEquityImportRecordsSuccess = (data) => ({
    type: actionType.DOWNLOAD_EQUITY_IMPORT_RECORDS_SUCCESS,
    payload: data,
});
export const downloadEquityImportRecordsFailure = (error) => ({
    type: actionType.DOWNLOAD_EQUITY_IMPORT_RECORDS_FAILURE,
    payload: error,
});